const { list: listPrograms } = require('./../../../program')
const getServiceFromPrograms = require('./../../tools/get-service-from-programs')

exports.get = function (state, serviceId) {
  return listPrograms(state)
    .then(programs => getServiceFromPrograms(programs, serviceId))
}
